import routes from 'global/Constants/routes';
import { lazy } from 'react';

const MyCustomerPage = lazy(() => import('../../pages/dashboard/client/ClientList'));
const MyCustomerCreate = lazy(() => import('../../pages/dashboard/client/ClientCreate'));
const MyCustomerUpdate = lazy(() => import('../../pages/dashboard/client/ClientUpdate'));

export const clientRoutes = (hasAccessLevel: (_level: number) => boolean) => [
  {
    path: routes.clientUpdate.path,
    component: MyCustomerUpdate,
    isPrivate: routes.clientUpdate.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.clientCreate.path,
    component: MyCustomerCreate,
    isPrivate: routes.clientCreate.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.client.path,
    component: MyCustomerPage,
    isPrivate: routes.client.isPrivate,
    accessRole: hasAccessLevel(10),
  },
];
